<template>
    <section>
        <div class="container pb-4">
            <div class="row">
                <div class="col-lg-12">
                    <h4 class="mt-5">我的车辆</h4>
                    <el-row :gutter="12">
                        <el-col v-for="item in cars" :key="item.CarID" :span="4">
                            <el-card shadow="hover" :body-style="{ padding: '0px' }">
                                <img :src="domain+'/Apps/JYJYManage/Preview/PreviewImage?id='+item.AttID" class="image">
                                <div style="padding: 4px;">
                                    <span>车牌:{{item.ChePaiHao}} <el-tag :type="item.ShenHeStatus==1?'success':'danger'" size="mini">{{item.ShenHeStatus==1?'已审核':'待审核'}}</el-tag> </span>
                                    <div class="bottom clearfix">
                                        <el-button type="text" @click="remove(item)" class="button danger">删除</el-button>
                                        <el-button type="text" @click="edit(item)" class="button">编辑</el-button>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="4">
                            <el-card shadow="always">
                                <div @click="openAddCarDialog" class="add_car">
                                    <i class="el-icon-plus"></i>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <el-dialog title="新增/编辑车辆" :visible.sync="dialogVisible" width="650px">
            <car-detail :licenseTypes="licenseTypes" :carModels="carModels" @uploadchange="uploadChange" @uploadfile="uploadFile" @uploadremove="uploadRemove" @closedialog="closedialog" @savecar="saveCar" :car="currentCar"></car-detail>
        </el-dialog>
    </section>
</template>
<script>
    import api from "../api";
    import axios from "axios";
    import util from "../libs/util";
    import carDetail from "../components/carDetail";
    export default {
        components: {
            carDetail
        },
        data() {
            return {
                domain: process.env.BASE_API,
                dialogVisible: false,
                currentCar: {
                    XingShiZhengImages: [],
                    CheLiangImages: []
                },
                licenseTypes: [],
                carModels: [],
                cars: []
            };
        },
        methods: {
            loadItems() {
                let _this = this
                api.myCars().then(res => {
                    if (res.data.Succeed) {
                        _this.cars = res.data.Data
                    }
                });
            },
            reload() {
                this.loadItems()
            },
            openAddCarDialog() {
                this.dialogVisible = true
            },
            closedialog() {
                this.dialogVisible = false;
            },
            saveCar(car) {
                let _this = this
                api.saveCar({
                    car: car
                }).then(res => {
                    if (res.data.Succeed) {
                        _this.dialogVisible = false
                        _this.currentCar = {}
                        _this.reload()
                    }
                })
            },
            edit(car) {
                let _this = this;
                api.getCarById({
                    carId: car.CarID
                }).then(res => {
                    if (res.data.Succeed) {
                        res.data.Data.CheLiangImages.forEach(element => {
                            element.url = process.env.BASE_API+'/Apps/JYJYManage/Preview/PreviewImage?id='+element.attid;
                        });
                        res.data.Data.XingShiZhengImages.forEach(element => {
                            element.url = process.env.BASE_API+'/Apps/JYJYManage/Preview/PreviewImage?id='+element.attid;
                        });
                        _this.currentCar = res.data.Data
                        _this.openAddCarDialog()
                    }
                })
            },
            remove(car) {
                let _this = this
                _this.$confirm("此操作要删除车辆, 是否继续?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    })
                    .then(() => {
                        api.deleteCar({
                            carId: car.CarID
                        }).then(res => {
                            if (res.data.Succeed) {
                                _this.reload()
                            }
                        })
                    })
                    .catch(() => {});
            },
            uploadFile(f) {
                let param = new FormData();
                param.append("file", f.file);
                param.append("attid", f.file.uid + f.file.size + Math.random());
                param.append("attname", f.file.name);
                param.append("type", f.data.type);
                let config = {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: util.cookies.get("access_token")
                    }
                };
                axios
                    .post(f.action, param, config) //上传图片
                    .then(response => {
                        f.onSuccess(response.data);
                    })
                    .catch(err => {
                        f.onError(err);
                    });
            },
            uploadChange(file, fileList) {
                if (file.response) {
                    fileList.forEach(function(item) {
                        if (item.name == file.name) {
                            item.attid = file.response.id;
                            item.type = file.response.type;
                            item.url = process.env.BASE_API+'/Apps/JYJYManage/Preview/PreviewImage?id='+file.response.id;
                        }
                    });
                    this.updateImgs(file, fileList);
                }
            },
            uploadRemove(file, fileList) {
                let _this = this;
                _this.updateImgs(file, fileList);
            },
            updateImgs(file, fileList) {
                if (file.type == '车辆照片') {
                    this.$set(this.currentCar, "CheLiangImages", fileList);
                } else if (file.type == '行驶证') {
                    this.$set(this.currentCar, "XingShiZhengImages", fileList);
                }else if (file.type == '交强险保单') {
                    this.$set(this.currentCar, "JiaoQiangXianImages", fileList);
                }else if (file.type == '商业险保单') {
                    this.$set(this.currentCar, "ShangYeXianImages", fileList);
                }else if (file.type == '道路运输证') {
                    this.$set(this.currentCar, "DaoLuImages", fileList);
                }
            },
            loadDictionaries() {
                let _this = this
                api.getDictionary({
                    search: {
                        IsEnabled: '',
                        PageNo: 1,
                        PageSize: 1000
                    },
                    tableName: 'carModel'
                }).then(res => {
                    _this.carModels = res.data.Data.Data
                })
                api.getDictionary({
                        search: {
                            IsEnabled: "",
                            PageNo: 1,
                            PageSize: 1000
                        },
                        tableName: "LicenseType"
                    })
                    .then(res => {
                        _this.licenseTypes = res.data.Data.Data;
                    });
            }
        },
        mounted() {
            this.loadItems()
            this.loadDictionaries()
        }
    };
</script>
<style scoped>
    .container {
        min-height: 600px;
    }
    .add_car {
        text-align: center;
        font-size: 50px;
        line-height: 2.7;
        cursor: pointer;
    }
    .add_car i {
        color: #aaa;
    }
    .el-col {
        margin-top: 16px;
    }
    .el-card__body img {
        height: 105px;
        width: 100%;
        object-fit: cover;
    }
    .bottom {
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/pages/MyCars.vue